// import { IStatisticState } from './types';

const initialState = {
  actionProcessing: false,
  statistic: {
    betCount: 0,
    totalBets: 0,
    totalWin: 0,
    totalNetwin: 0,
    totalNetwinByDates: [],
    totalUserBalance: 0,
    totalAgentBalance: 0,
    usersCount: 0,
    totalMargin: 0,
    activeUser: 0,
    totalMetricStatistic: {
      metricName: null,
      totalDiff: 0,
      diffPercent: 0,
      currentPeriod: {
        total: 0,
        totalByDate: [],
      },
      previousPeriod: {
        total: 0,
        totalByDate: [],
      },
    },
    directTotalNetwin: 0,
    rankedAgents: [],
  },
  balanceStatistic: [],
};

export default initialState;
